export const QualityDisputeReasons = {
  INCORRECT_STALENESS_REPORTED: 'INCORRECT_STALENESS_REPORTED',
  INCORRECTLY_FLAGGED_ABANDONWARE: 'INCORRECTLY_FLAGGED_ABANDONWARE',
  INCORRECTLY_FLAGGED_EMPTY: 'INCORRECTLY_FLAGGED_EMPTY',
} as const;

export type QualityDisputeReasonsKey = keyof typeof QualityDisputeReasons;

export const QualityDisputeReasonLabels: Record<QualityDisputeReasonsKey, string> = {
  INCORRECT_STALENESS_REPORTED: 'Incorrect staleness / version age reported',
  INCORRECTLY_FLAGGED_ABANDONWARE: 'Package incorrectly flagged as abandonware',
  INCORRECTLY_FLAGGED_EMPTY: 'Package incorrectly flagged as empty',
};
export type QualityDisputeReasonsType = typeof QualityDisputeReasons[keyof typeof QualityDisputeReasons];

export type QualityDispute = {
  id: number;
  createdBy: number;
  createdAt: Date;
  resolvedBy: number | null;
  resolvedAt: Date | null;
  disputedIssueId: number;
  reason: QualityDisputeReasonsType;
  comment: string | null;
};
